import { useState } from "react";
import Button from "../utils/Button";
import { documentIcon } from "../utils/svg";
import apiCall from "../network/api";
import { useNavigate } from "react-router-dom";
import { EmptyAssignment } from "./EmptyAssignment";

export const DocumentList = ({
  assignmentId,
  rowId,
  status,
  name,
  documents,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleDownloadFile = async (doc) => {
    try {
      setLoading(true);

      const path = new URL(doc?.url).pathname.split("/").filter(Boolean);
      const folderName = `${path[path.length - 4]}/${path[path.length - 3]}/${path[path.length - 2]}`;
      const fileName = path[path.length - 1];

      const files = await apiCall({
        endpoint: "/generate-download-urls",
        method: "POST",
        data: { folderName, isDownload: true },
      });

      const file = files?.find((f) => f.name.includes(fileName));

      if (file?.url) {
        const link = document.createElement("a");
        link.href = file.url;
        link.download = file.name || fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (err) {
      if (err?.status === 403) {
        localStorage.clear();
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadAll = async () => {
    if (!documents?.length) return;

    try {
      setLoading(true);

      const path = new URL(documents[0]?.url).pathname
        .split("/")
        .filter(Boolean);

      const folderName = `${path[path.length - 4]}/${path[path.length - 3]}/${path[path.length - 2]}`;

      const files = await apiCall({
        endpoint: "/generate-download-urls",
        method: "POST",
        data: { folderName, isDownload: true },
      });

      for (const file of files || []) {
        if (!file?.url) continue;

        const link = document.createElement("a");
        link.href = file.url;
        link.download = file.name || "";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // small delay so browser processes each download
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (err) {
      if (err?.status === 403) {
        localStorage.clear();
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  function trimFilename(filename, fileextension) {
    if (filename.length > 30) {
      return filename.slice(0, 22) + "..." + fileextension?.split("/")?.[1];
    }
    return filename;
  }

  return (
    <div className="bg-white rounded-lg overflow-hidden">
      {status !== "noAssignment" ? (
        <div className="p-6 space-y-4">
          <h2 className="font-bold text-gray-500">Assignment Docs</h2>
          <div className="border">
            <div className="bg-gray-100 rounded p-3 flex gap-2.5 items-center">
              <p className="text-sm font-bold text-gray-500">Assignment ID</p>
              <p className="text-sm  text-gray-800">#{assignmentId}</p>
            </div>

            <div>
              <div className="p-3">
                {documents?.map((document) => (
                  <div
                    className="flex items-center space-x-3 p-4 bg-white rounded-lg shadow-sm border border-gray-200 mb-3 cursor-pointer hover:bg-gray-50 transition-colors duration-150"
                    onClick={() => handleDownloadFile(document)}
                  >
                    <span> {documentIcon()}</span>
                    <span className="text-gray-700 text-sm">
                      {trimFilename(document?.name)}
                    </span>
                  </div>
                ))}
              </div>
              {documents?.length > 0 && (
                <div className="p-3 border-t">
                  <Button
                    text={"Download All"}
                    size={"md"}
                    onClick={(e) => {
                      handleDownloadAll(e);
                    }}
                    loading={loading}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <EmptyAssignment
          name={name}
          message={"Your docs will be visible after you have an assigned AOG."}
        />
      )}
    </div>
  );
};
